import Moment from 'moment'
import { getRootPluaralTranslator } from '@utils/get-module-translator'

const __tc = getRootPluaralTranslator()

export default function daytime(value) {
  if (value === 0 || value === undefined || value === null) {
    return 0 + ' ' + __tc('minutes', 0)
  }
  const m = Moment.duration(value, 'milliseconds')
  const hierarchy = ['months', 'days', 'hours', 'minutes']

  // Helper to check if a value is effectively an integer
  const isInteger = (val) => Math.abs(val - Math.round(val)) < 0.02

  for (const unit of hierarchy) {
    const val = m.as(unit)
    // strict check: value must be effectively an integer and at least 1
    if (Math.round(val) >= 1 && isInteger(val)) {
      return `${Math.round(val)} ${__tc(unit, Math.round(val))}`
    }
  }

  // Fallback to hours if nothing else matches (as it was doing before)
  return `${m.asHours()} ${__tc('hours', m.asHours())}`
}
